import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '@shared/shared.module';

import { AgentScoreModule } from './modules/agent-score/agent-score.module';
import { AgentFeedbackModule } from './modules/agent-feedback/agent-feedback.module';
import { AgentRealPropertyListModule } from './modules/agent-real-property-list/agent-real-property-list.module';

import { RealPropertyAgentProfileComponent } from './real-property-agent-profile.component';
import { TopModule } from '@app/navigation/components/top/top.module';
import { MenuModule } from '@app/navigation/components/menu/menu.module';

const ROUTES: Routes = [
  {
    path: '',
    component: RealPropertyAgentProfileComponent,
  },
];

@NgModule({
  declarations: [RealPropertyAgentProfileComponent],
  imports: [
    CommonModule,
    SharedModule,
    AgentScoreModule,
    AgentFeedbackModule,
    AgentRealPropertyListModule,
    RouterModule.forChild(ROUTES),
    TopModule,
    MenuModule
  ],
})
export class RealPropertyAgentDetailsModule {}
